export default __webpack_public_path__ + "media/clock-progress.51ca792f.webp";